<template>
  <router-view />
</template>

<script>
export default {
  name: 'DataReport',
}
</script>
